import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useLocation } from 'react-router-dom';
import { ThemeToggle } from './ThemeToggle';

/**
 * Floating ThemeToggle visible everywhere INSIDE the app (after login),
 * fixed at the top-right corner of the viewport.
 * Hidden on /login and reset-password pages since LoginPage has its own toggle.
 */
export const FloatingThemeToggle = () => {
  const { user } = useAuth();
  const location = useLocation();
  const path = location.pathname || '';
  const hiddenOnRoute = path === '/login' || path.startsWith('/reset-password');
  if (!user || hiddenOnRoute) return null;
  return (
    <div className="fixed top-3 right-3 md:top-4 md:right-4 z-[100]" data-testid="floating-theme-toggle">
      <ThemeToggle className="shadow-md" />
    </div>
  );
};

export default FloatingThemeToggle;
